var map = {
	"./TekSystems.png": 782,
	"./aboutUs.jpeg": 826,
	"./ai.jpeg": 627,
	"./cloud.jpeg": 362,
	"./consulting.jpeg": 57,
	"./default.png": 741,
	"./diego.jpeg": 531,
	"./digitalExperiences.png": 111,
	"./edu.jpeg": 623,
	"./fitideas.png": 99,
	"./kiindred.png": 36,
	"./lahiru.jpeg": 652,
	"./logo.png": 153,
	"./logo192.png": 21,
	"./logo512.png": 641,
	"./logo_new_big.png": 333,
	"./logo_old.png": 271,
	"./logo_old_cat.png": 850,
	"./mobile.jpeg": 891,
	"./nelson.jpeg": 20,
	"./tiana.jpeg": 104,
	"./ux-ui.jpeg": 205,
	"./web.jpeg": 473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;